import { render } from "./popover.vue?vue&type=template&id=0d5ae99c&ts=true"
import script from "./popover.ts?vue&type=script&lang=ts&external"
export * from "./popover.ts?vue&type=script&lang=ts&external"

import "./popover.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__